function importAll(r) {
  return r.keys().map(r);
}

const Header_L = importAll(require.context('../assets/photos/Header_L', false, /\.(png|jpe?g|svg)$/));

export default Header_L;